import { render } from "./YourDetailsRSW.vue?vue&type=template&id=606adb35&scoped=true"
import script from "./YourDetailsRSW.vue?vue&type=script&lang=js"
export * from "./YourDetailsRSW.vue?vue&type=script&lang=js"

import "./YourDetailsRSW.vue?vue&type=style&index=0&id=606adb35&lang=scss"
import "./YourDetailsRSW.vue?vue&type=style&index=1&id=606adb35&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606adb35"]])

export default __exports__